import React from "react";
import { format } from "date-fns";

import styles from "./ChuzhiNotice.module.css";

function ChuzhiNotice(props: any) {
  const { list } = props;
  return (
    <div className={styles.item}>
      <table>
        <colgroup>
          <col width="80%" />
          <col width="20%" />
        </colgroup>
        <thead className={styles.itemHead}>
          <tr>
            <th>公告标题</th>
            <th>发布时间</th>
          </tr>
        </thead>
        <tbody className={styles.itemBody}>
          {list.map((item: any, index: number) => {
            const { title, publishTime, id } = item;
            return (
              <tr key={index}>
                <td>
                  <a
                    className={styles.itemTitle}
                    href={`https://zcch.jd.com/newNoticeDetail/${id}?type=chuzhi`}
                    target="_blank"
                  >
                    {title}
                  </a>
                </td>
                <td>
                  <div className={styles.itemTime}>
                    {!!publishTime && format(publishTime, "yyyy年MM月dd日")}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default ChuzhiNotice;
